import { HeatExchangerAnimatic, HeatExchangerAnimaticProps } from '@crossnokaye/ux-animatics';

import { AnimaticHeatExchangerConfigKind } from '@repo/sdk/models/components';

import { ANIMATIC_PRIMARY_LABEL } from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticHeatExchanger = ({
  config,
  labels,
  state,
  className,
}: AnimaticConfigProps) => {
  const kind = (config.specificAnimaticConfig?.heatExchanger?.kind ??
    AnimaticHeatExchangerConfigKind.PlateFin) as HeatExchangerAnimaticProps['type'];
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <HeatExchangerAnimatic primaryLabel={primaryLabel?.text} state={state} type={kind} />
    </ScaledAnimatic>
  );
};
